import { render, staticRenderFns } from "./SCard.vue?vue&type=template&id=f08e1b9c&scoped=true&"
var script = {}
import style0 from "./SCard.vue?vue&type=style&index=0&id=f08e1b9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08e1b9c",
  null
  
)

export default component.exports